import SectionHeading from "@/components/base/SectionHeading";
import { principles, stats } from "@/mocks/site";

export default function PrinciplesSection() {
  return (
    <section className="border-y border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <SectionHeading
          eyebrow="编辑原则"
          title="可信度来自长期的一致"
          desc="爆料最容易变成情绪，我们想做的是把情绪背后的线索整理清楚。以下四条是我们处理每一条线索的底线。"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {principles.map((item, i) => (
            <div
              key={item.title}
              className="reveal flex flex-col rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-600 text-background-50">
                <i className={`${item.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              <span className="mt-4 font-heading text-xs text-background-400">原则 0{i + 1}</span>
            </div>
          ))}
        </div>

        <div className="reveal mt-8 grid grid-cols-2 gap-px overflow-hidden rounded-lg bg-background-300 lg:grid-cols-4">
          {stats.map((s) => (
            <div key={`band-${s.label}`} className="bg-secondary-900 px-5 py-7 text-center">
              <p className="font-heading text-3xl font-black text-background-50">{s.value}</p>
              <p className="mt-2 text-xs font-label tracking-wide text-secondary-200">
                {s.label}（{s.unit}）
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}